var site = {
	rate : 500,
	// prefix : '/keating'
	prefix : ''
};

Object.size = function(obj) {
	var size = 0, key;
	for (key in obj) {
		if (obj.hasOwnProperty(key)){
			size++;
		}
	}
	return size;
};

(function($){

  var md = new MobileDetect(window.navigator.userAgent);

	var $wrapper, $slider, $preloader, $pwrapper, $pslider, $ppreloader;

  if( $('.banner').length ){
    $wrapper = $('.banner');
    $slider = $('.banner-cycle');
    $preloader = $('.banner-preloader');

    $wrapper.append('<div class="slideshow-loader"></div>');
    $wrapper.find('.slideshow-loader').hide().fadeIn();

    $preloader.imagesLoaded(function(){

      $wrapper.find('.slideshow-loader').fadeOut(500);

      $slider.cycle({
        speed : 500,
        timeout : 5000,
        swipe : true,
        slides : "> .cycle-slide",
        fx : 'fadeout',
        swipeFx :  'scrollHorz'
      });
      $slider.delay(500).fadeIn('slow');

    });

    $('.banner .hide-banner').click(function(){
      $wrapper.slideUp('slow',function(){
        $slider.cycle('destroy');
      });
    });

  }

  $('.main-navbar .menu-item-has-children').not('.current-page-ancestor, .current-menu-ancestor, .current-menu-parent').hoverIntent(function(){
    $(this).find('.sub-menu').fadeIn('slow');
    $('.main-navbar').append('<div class="hover-bg" />');
    $('.main-navbar .hover-bg').fadeIn('slow');
  },function(){
    $(this).find('.sub-menu').fadeOut('slow');
    $('.main-navbar .hover-bg').fadeOut('slow',function(){
      $(this).remove();
    });
  });

   if( $('.page-banner').length ){
    $pwrapper = $('.page-banner');
    $pslider = $('.page-banner-cycle');
    $ppreloader = $('.page-banner-preloader');

    $pwrapper.append('<div class="slideshow-loader"></div>');
    $pwrapper.find('.slideshow-loader').hide().fadeIn();

    $ppreloader.imagesLoaded(function(){

      $pwrapper.find('.slideshow-loader').fadeOut(500);

      $pslider.cycle({
        speed : 500,
        timeout : 5000,
        swipe : true,
        slides : "> .cycle-slide",
        fx : 'fadeout',
        swipeFx :  'scrollHorz'
      });
      $pslider.delay(500).fadeIn('slow');

    });

  }

  function initializeMap(args) {

      var venue = new google.maps.LatLng(args.latitude, args.longitude);
      var mapOptions = {
        center: venue,
        scrollwheel: false,
        zoom: 16,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        zoomControl: true,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.DEFAULT
        }
      };

      var map = new google.maps.Map(document.getElementById(args.id),mapOptions);

      var marker = new google.maps.Marker({
        position: venue,
        map: map,
        animation: google.maps.Animation.DROP,
        title:location.title
      });

    }

  if( $('.gmap').length ){
    $('.gmap').each(function(){
      initializeMap({ longitude: $(this).data('lng'), latitude: $(this).data('lat'), id: $(this).attr('id') });
    });
  }



  // maybe?
  // http://noe-interactive.com/demo/animated-grid/examples/packery/

  // $('.toggle').click(function(){
  //   $(this).toggleClass('active');
  // });

  $('.i-toggle').click(function(){
    $(this).toggleClass('active');
    $('.info-ribbon').slideToggle();
  });

  $('#mobile-toggle').sidr({
      name: 'sidr-navbar',
      source: '#nav-sidebar',
      side: 'right',
      speed: 250,
      onOpen : function(){
        $('#mobile-toggle').toggleClass('active');
      },
      onClose : function(){
        $('#mobile-toggle').toggleClass('active');
      }
    });

  $('.modal-cover').delay(500).fadeIn(250,function(){
    $('#modal').fadeIn(250);
  }); 

  $('.modal-close,.modal-cover').click(function(){
    Cookies.set('liv-popup-closed', '1');
    $('.modal-cover,#modal').fadeOut(250,function(){ $(this).remove(); });
    return false;
  });

  var countOptions = {
    useEasing : false, 
    useGrouping : true, 
    separator : ',', 
    decimal : '.', 
    prefix : '£', 
    suffix : '' 
  };
  var demo = new CountUp("amount", 0, parseInt($('#amount').data('amount')), 0, 2.5, countOptions);
  
  setTimeout(function(){
    demo.start();
  }, 1000);

})(jQuery);